<template>
  <div class="bucketPopupMainContainer">
    <transition name="fade" mode="out-in">
      <modal
        v-if="!showCreate"
        :value="!showCreate"
        :title="`${$t('common.add')} ${$t('band.list00')}`"
        @input="$emit('close')"
      >
        <add_to_bucket
          :influencer="influencer"
          @create="showCreate = true"
          @close="close"
        />
      </modal>
      <modal
        v-else
        :value="showCreate"
        :has-cancel="true"
        :title="$t('agency.favorites.bucketCreator00')"
        @input="close"
        @cancel="showCreate = false"
      >
        <create_bucket @cancel="showCreate = false" />
      </modal>
    </transition>
  </div>
</template>

<script>
import modal from "~/components/shared/modal"
import add_to_bucket from "~/components/agency/favorites/addToBucket"
import create_bucket from "~/components/agency/favorites/bucketCreator"

import resize_mixin from "~/mixins/resize"

export default {
  components: {
    modal,
    add_to_bucket,
    create_bucket,
  },
  mixins: [resize_mixin],
  props: {
    influencer: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      showCreate: false,
    }
  },
  methods: {
    close: function () {
      this.$emit("close")
    },
  },
}
</script>

<style scoped src="./bucketPopup.css"></style>
<style scoped src="./bucketPopup768.css"></style>
